import budgetSlider from 'assets/core/js/page/search/budgetSlider'
import submitFilterForm from './submitFilterForm'

export default function (): void {
  budgetSlider({ callbackChange: submitFilterForm })
}
